import { ApiBody, friendlyError, reasonOf } from './brdApi';

/**
 * What every store call resolves with — never a thrown error, so a screen
 * always gets the API's message and, for a free-plan limit, its reason
 * (plan_*). `data` on a failure is the refusal's own data (e.g. the campaign a
 * half-done request still created).
 */
export type Result<T> =
  | { ok: true; data: T; info: string }
  | { ok: false; message: string; reason?: string; data?: any };

/**
 * A body as a Result: success when `status === 1` and `pick` finds the data.
 * A plan-limit refusal keeps the API's own wording; anything else goes through
 * friendlyError.
 */
export function toResult<T>(body: ApiBody, pick: (body: ApiBody) => T | undefined | null, fallback: string): Result<T> {
  if (body?.status === 1) {
    const data = pick(body);
    if (data !== undefined && data !== null) return { ok: true, data, info: String(body?.info || '') };
  }
  const reason = reasonOf(body);
  const message = reason && reason.startsWith('plan_') ? String(body?.info || fallback) : friendlyError(body?.info, fallback);
  return { ok: false, message, reason, data: body?.data };
}
